import * as type from "../../types/API/customFields";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
  successMessage: '',
  deleteSuccessMessage: ''
};

export const getCustomFieldsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_CUSTOM_FIELDS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_CUSTOM_FIELDS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData
      };
    case type.GET_CUSTOM_FIELDS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const addCustomFieldsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.ADD_CUSTOM_FIELDS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.ADD_CUSTOM_FIELDS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData.data,
        successMessage: action.payload.responseData.message
      };
    case type.ADD_CUSTOM_FIELDS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const editCustomFieldsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.EDIT_CUSTOM_FIELDS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.EDIT_CUSTOM_FIELDS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.EDIT_CUSTOM_FIELDS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteCustomFieldsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_CUSTOM_FIELDS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.DELETE_CUSTOM_FIELDS_SUCCESS:
      return {
        error: null,
        loading: false,
        deleteSuccessMessage: action?.payload?.responseData?.message
      };
    case type.DELETE_CUSTOM_FIELDS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const editPermissionReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.EDIT_PERMISSIONS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.EDIT_PERMISSIONS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action?.payload?.responseData?.message
      };
    case type.EDIT_PERMISSIONS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const editCustomFieldReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.EDIT_CUSTOM_FIELD:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.EDIT_CUSTOM_FIELD_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData?.message,
      };
    case type.EDIT_CUSTOM_FIELD_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
